var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIconChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 62,
    viewBox: "0 0 10 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.99999,
    height: 58,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 0 58)",
    fill: "#5B94EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.66667,
    height: 6.66667,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 6.66675 57.5835)",
    fill: "#5B94EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 56.75L5 52.4199L5 61.0801L10 56.75Z",
    fill: "#5B94EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconChild);
export default __webpack_public_path__ + "static/media/arrowIconChild.f1421a9bc92fdd65382c919c1971fc37.svg";
export { ForwardRef as ReactComponent };